import { HttpContext } from '@angular/common/http';
import { skipDefaultErrorHandling } from '@fluxys/common';
import { withLoadingSpinner } from '@fluxys/primeng';

export class HttpContextFactory {
  static create(context: string): HttpContext {
    return withLoadingSpinner(context, skipDefaultErrorHandling());
  }
}
